import { css } from "styled-components";

export default css`
    *:has(.fluid-accent) {
        max-width: 100%;
        position: relative;
    }

    .fluid-accent {
        max-width: 100%;
        overflow: hidden;
        position: relative;
        text-overflow: ellipsis;
        white-space: nowrap;

        &::before {
            background: var(--color-fluid, aquamarine);
            content: "";
            height: 1.5rem;
            left: -1px;
            position: absolute;
            top: .8rem;
            transition: width 200ms;
            width: 0;
            z-index: -1;
        }
    }

    &:hover {
        .fluid-accent::before {
            width: calc(100% + 2px);
        }
    }
`;

export const FluidAccent2 = css`
    &::before {
        background: var(--color-fluid, aquamarine);
        content: "";
        height: .7em;
        left: -1px;
        position: absolute;
        top: .5em;
        transition: width 200ms;
        width: 0;
        z-index: -1;
    }

    &:hover {
        &::before {
            width: calc(100% + .2em);
        }
    }
`;
